/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { defineAsyncComponent } from '@vue/composition-api';

/** 天降红包 */
export const TianJiangMarket = defineAsyncComponent(() => import(
  /* webpackChunkName: "red-packet" */'@/views_v2/home/components/red-packet'
));

/** 首页打开时的广告弹窗：临额弹窗、营销弹窗... */
export const PageLoadedPopup = defineAsyncComponent(() => import(
  /* webpackChunkName: "adv-home-popup" */'@/components/adv-components/adv-home-popup'
));

/** 额度更新-弹窗：如，预授信出额 */
export const CreditAmountAlterPopup = defineAsyncComponent(() => import(
  /* webpackChunkName: "credit-amount-alter-popup" */'./CreditAmountAlterPopup/index.vue'
));

/** 逾期弹窗 */
export const RepayOverdueAlterPopup = defineAsyncComponent(() => import(
  /* webpackChunkName: "repay-overdue-alter-popup" */'./RepayOverdueAlterPopup/index.vue'
));
